const utils = require('analytics/utils');
const anaConsts = require('analytics/constants');
const deepExtend = require('utils/deepExtend');
const basketUtils = require('utils/Basket');
const skuUtils = require('utils/Sku');

module.exports = function (data) {

    const currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
    const {
        sku, analyticsData = {}
    } = data;
    const {
        containerTitle, productId, isAddFullSize, isBIRBReward
    } = analyticsData;

    /* ILLUPH-119839
     * According to JIRA and business, requirement is to have prop55 populate with
     * actionCampaignString listed below only for the products within the
     * purchases carousel on the profile lists page. (loves and services cannot have rewards)
     * On other pages we will continue to populate eVar75 with actionCampaignString.
    */
    const addText = isAddFullSize ? 'add-full-size' : 'add-to-basket';
    const isBiReward = skuUtils.isBiReward(sku);
    let actionInfo = isBIRBReward || isBiReward ? [containerTitle, addText].join(':') : addText;
    let internalCampaign = addText;
    if (containerTitle) {
        const actionCampaignString =
            `${containerTitle}:${sku.productId || productId}:${addText}`;
        if (containerTitle === anaConsts.CAROUSEL_NAMES.PURCHASES) {
            actionInfo = actionCampaignString;
        } else {
            internalCampaign = isBIRBReward ?
                `${containerTitle}:${sku.productId || productId}:${addText.split(' ').join('-')}` :
                actionCampaignString;
        }
    }

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                biRealTimePointStatus: basketUtils.getAvailableBiPoints(),
                biRewardType: sku.biType,
                actionInfo,
                linkName: isAddFullSize ? 'Add Full Size' : 'Add To Basket',
                internalCampaign
            }
        }
    });
};
